import { Flex } from "@similarweb/ui-components/foundations";

import { HealthDynamicsCard } from "./health/HealthDynamicsCard";
import { NewKeywordsCard } from "./new-keywords/NewKeywordsCard";
import { TotalSearchesCard } from "./total-searches/TotalSearchesCard";

export const SearchTrendsMetricCards = () => (
    <Flex
        gap="16px"
        alignItems="stretch"
        margin="0 0 24px 0"
        data-automation="search-trends-metric-cards"
    >
        <TotalSearchesCard />
        <HealthDynamicsCard />
        <NewKeywordsCard />
    </Flex>
);
